import _ from 'lodash';
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { makeandcheckerService, usersService } from '../../../../services';
import { FilterQueryParams, downloadReport } from '../../../../helpers';
import { useClientsUIContext } from '../../list/ClientsUIContext';
import { UIHelpers } from '../../../../constants/pages/UIHelpers';
import { Card, CardBody, CardHeaderToolbar, HeaderTitle, MenuSVG, Table } from '../../../../components';
import ClientDialogConfirm from '../dialog/ClientDialogConfirm';
import clientsDropColumns from './ClientsColumnsMC';
import actionTypes from '../../../../constants/makeandchecker/actionsTypeId';
import ClientsDropFilters from '../ClientsDropFilter';
import { ROLES } from '../../../../constants/permissions/roles';
import page from '../../../../constants/pages/page';
import { useTranslation } from 'react-i18next';
import CustomAlert from '../../../../components/Alert';

function ClientsMCTable ({ user, calculateBadges, clientsDropBadges }) {
    const { t } = useTranslation();
    // sortedKeyMap
    const customSortedKeyMap = { 'status.description': 'id_action_status' };
    const { sortedKeyMap, defaultSorted } = UIHelpers(customSortedKeyMap);

    const clientsDropFiltersRef = useRef();
    // States

    // Context state
    const clientsMCUIContext = useClientsUIContext();
    const clientsMCUIProps = useMemo(() => {
        return {
            isLoading: clientsMCUIContext.isLoading,
            setIsLoading: clientsMCUIContext.setIsLoading,
            queryParams: clientsMCUIContext.queryParams,
            setQueryParams: clientsMCUIContext.setQueryParams
        };
    }, [clientsMCUIContext]);

    // List state
    const [clientsList, setClientsList] = useState(null);

    // Dialogs state
    const [dialog, setDialog] = useState(null);

    // Alert states

    const [openAlert, setOpenAlert] = useState(false);
    const [alert, setAlert] = useState({
        severity: '',
        title: '',
        description: '',
        className: ''
    });

    // Roles state
    const [userRoles, setUserRoles] = useState({
        admin: false,
        operator: false
    });

    const [totalClients, setTotalClients] = useState('0');

    const fetchUserRole = () => {
        // Check if logged in user is Admin
        const prepareRoles = {
            admin: false,
            operator: false
        };

        for (const userRole of user.roles) {
            if (userRole.role.id === ROLES.admin) {
                prepareRoles.admin = true;
            }
            if (userRole.role.id === ROLES.operator) {
                prepareRoles.operator = true;
            }
        }

        setUserRoles(prepareRoles);
        clientsMCUIProps.setIsLoading(true);
    };
        // Functions

    // Ids clients to drop
    const idDropList = [];

    const fetchClients = async (pageSize, page) => {
        // change state isLoading
        clientsMCUIProps.setIsLoading(true);

        // Filter for M&C
        const clientsDropList = [];
        const usersCreatedMC = [];

        const filterMc = clientsMCUIProps.queryParams.filters || new FilterQueryParams();

        const { sortField, sortOrder } = clientsMCUIProps.queryParams;

        const option = {
            order: `${sortedKeyMap[sortField] || sortField}-${sortOrder.toUpperCase()}`,
            pageSize: clientsMCUIProps.queryParams.pageSize,
            page: page || clientsMCUIProps.queryParams.pageNumber,
        };

        filterMc.equal('idType', actionTypes.updateUserStatus);

        option.filters = filterMc.build();

        await makeandcheckerService
            .getActions(option)
            .then(clients => {
                clients.forEach(c => {
                    idDropList.push(c.metadata.path.id);
                    clientsDropList.push(c);
                    if (c.metadata.idCreatedBy) usersCreatedMC.push(c.metadata.idCreatedBy);
                });
            })
            .catch(e => {
                setAlert((prevAlert) => ({
                    ...prevAlert,
                    severity: 'error',
                    title: t('errors.generalTitle'),
                    description: t('errors.generalDescription'),
                    className: 'clientsMC_Alert--error'
                }));
                setOpenAlert(true);
                console.error(e);
            });

        if (clientsDropList.length === 0) {
            clientsMCUIProps.setIsLoading(false);
            return setClientsList(null);
        }

        await fetchUsers(idDropList)
            .then(users => {
                // eslint-disable-next-line array-callback-return
                users.map(client => {
                    if (clientsDropList && _.includes(idDropList, client.id)) {
                        clientsDropList.forEach(c => {
                            if (client.id === c.metadata.path.id) {
                                c.client = client;
                                c.mc_created_at = c.created_at;
                            }
                        });
                    }
                });
            });
        //             // Find all BO users create M&C
        await fetchUsers(usersCreatedMC)
            .then(user => {
                clientsDropList.forEach(c => {
                    if (c.metadata.idCreatedBy) {
                        c.metadata.user = _.find(user, ['id', Number(c.metadata.idCreatedBy)]);
                    }
                });
                setClientsList(clientsDropList);
                // change state isLoading
                clientsMCUIProps.setIsLoading(false);
            //     return clients;
            })
            .catch(e => {
                setAlert((prevAlert) => ({
                    ...prevAlert,
                    severity: 'error',
                    title: t('errors.generalTitle'),
                    description: t('errors.generalDescription'),
                    className: 'clientsMC_Alert--error'
                }));
                setOpenAlert(true);
                console.error('Error set client', e);
                // change state isLoading
                clientsMCUIProps.setIsLoading(false);
                return [];
            });
    };

    const fetchUsers = (ids = []) => {
        const options = {
            filters: `id in [${ids.join(';')}]`,
            pageSize: 100000
        };

        return usersService.find(options);
    };

    const getData = () => {
        fetchClients();
        getTotalActions();
    };

    const getTotalActions = async () => {
        const filters = clientsMCUIProps.queryParams.filters || new FilterQueryParams();
        filters.equal('idType', actionTypes.updateUserStatus);
        const options = {
            unionPeople: true,
            pageSize: 100000
        };
        options.filters = filters.build();
        await makeandcheckerService
            .getActions(options)
            .then(clients => {
                setTotalClients(clients.length);
            })
            .catch(e => console.error(e));
    };

    // Events

    // Handle query params changes. On any param change, fetch clients.
    useEffect(() => {
        if (JSON.stringify(clientsMCUIProps.queryParams.url) !== undefined) {
            getData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientsMCUIProps.queryParams]);
    // eslint-disable-next-line
    useEffect(() => fetchUserRole(), []);

    const handleClickDropClient = id => {
        const clientToDrop = _.find(clientsListToDrop, ['id', id]);
        setDialog({
            type: 'confirm',
            client: clientToDrop
        });
    };

    const handleCloseDialog = (toggleRefresh) => {
        setDialog(null);
        if (toggleRefresh) {
            clientsMCUIProps.setQueryParams(prev => ({ ...prev, pageNumber: 1, refresh: !clientsMCUIProps.queryParams.refresh }));
        }
    };

    const resetFilters = () => {
        if (clientsDropFiltersRef.current) {
            clientsDropFiltersRef.current.reset();
        }
    };
    const download = () => {
        downloadReport(clientsMCUIContext);
    };

    useEffect(() => {
        clientsMCUIProps.setQueryParams(prev => ({ ...prev, pageSize: localStorage.getItem('sizePerPage') || page.pageSize }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Order M&C list to drop
    const clientsListToDrop = clientsList && clientsList.length ? _.orderBy(clientsList, ['makeandchecker.created_at'], ['desc']) : [];
    // Main Component
    return (
        <>
            {dialog && dialog.type === 'confirm' && (
                <ClientDialogConfirm
                    user={user}
                    userRoles={userRoles}
                    open={true}
                    clientToDrop={dialog.client}
                    onClose={handleCloseDialog}
                    setAlert={setAlert}
                    setOpenAlert={setOpenAlert}
                />
            )}
            <CustomAlert
                openAlert={openAlert}
                setOpenAlert={setOpenAlert}
                alert={alert}
                setAlert={setAlert}
            />
            <Card>
                <HeaderTitle
                    title={t('management.unsubscription.title')}
                    total={clientsDropBadges}
                    reset={resetFilters}
                    icon={(<MenuSVG />)}
                    download={download}
                    UIProps={clientsMCUIProps}
                />
                <CardHeaderToolbar>
                    <ClientsDropFilters ref={clientsDropFiltersRef}/>
                </CardHeaderToolbar>
                <CardBody>
                    <Table
                        data={clientsList}
                        columns={clientsDropColumns({ handleClickDropClient })}
                        sort={defaultSorted}
                        onChange={clientsMCUIProps.setQueryParams}
                        isLoading={clientsMCUIProps.isLoading}
                        total={totalClients}
                        pagination={{
                            sizePerPage: clientsMCUIProps.queryParams.pageSize,
                            page: clientsMCUIProps.queryParams.pageNumber
                        }}
                    />
                </CardBody>
            </Card>
        </>
    );
}

const mapStateToProps = ({ auth: { user } }) => ({
    user
});

export default connect(mapStateToProps)(ClientsMCTable);
